import React from "react";
import { Button } from "../../../ui/button";
import { Plus } from "lucide-react";
import { CanvasContextMenuState } from "../hooks/hooks";

interface CanvasContextMenuProps {
  canvasContextMenu: CanvasContextMenuState;
  onAddNode: (position: { x: number; y: number }) => void;
  onHide: () => void;
}

const CanvasContextMenu: React.FC<CanvasContextMenuProps> = ({
  canvasContextMenu,
  onAddNode,
  onHide,
}: CanvasContextMenuProps) => {
  if (!canvasContextMenu.visible) {
    return null;
  }

  return (
    <div
      data-context-menu
              className="fixed bg-background border border-border rounded-md shadow-lg z-40 py-1 min-w-[120px]"
      style={{
        top: canvasContextMenu.screenPosition.y,
        left: canvasContextMenu.screenPosition.x,
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <Button
        variant="ghost"
        size="sm"
        className="w-full justify-start gap-2 h-8 px-3 rounded-none hover:bg-accent"
        onClick={() => {
          onAddNode({ x: canvasContextMenu.x, y: canvasContextMenu.y });
          onHide();
        }}
      >
        <Plus className="w-4 h-4" />
        Add Node
      </Button>
    </div>
  );
};

export default CanvasContextMenu; 